import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IonButton, IonCol, IonRow } from '@ionic/angular/standalone';
import { map, take } from 'rxjs';
import { UserRoles } from 'src/app/core/enums';
import {
  HomeMessage,
  MESSAGE_TYPE,
} from 'src/app/core/models/home/message.model';
import { UserService } from 'src/app/core/services/admin/user/user.service';
import { HomeMessageService } from 'src/app/core/services/home/home-message.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { IMAGE_SRC } from '../shared/shared-constants';
import { EditMessageModalComponent } from './edit-message-modal/edit-message-modal.component';
import { HomeCardComponent } from './home-card/home-card.component';
import { CARD_TEXT, DISPLAY_CONSTS, PDF } from './home.constants';
import { MessageCardComponent } from './message-card/message-card.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [
    IonRow,
    IonCol,
    MessageCardComponent,
    HomeCardComponent,
    AsyncPipe,
    CommonModule,
    IonButton,
  ],
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  userService = inject(UserService);
  private commonUtils = inject(CommonUtils);
  private homeService = inject(HomeMessageService);
  private dialog = inject(MatDialog);

  readonly DISPLAY = DISPLAY_CONSTS;
  readonly CARD_TEXT = CARD_TEXT;
  readonly SRC = IMAGE_SRC;
  readonly MESSAGE_TYPE = MESSAGE_TYPE;
  readonly USER_ROLE = UserRoles;

  messages: HomeMessage[] = [];

  ngOnInit(): void {
    // Commenting out for now until BE apis are done
    // this.loadMessages();
  }

  loadMessages() {
    this.homeService
      .getCurrentMessages()
      .pipe(
        map((val) => {
          this.messages = val?.response?.messages ?? [];
        }),
      )
      .subscribe();
  }

  addMessage() {
    this.dialog
      .open(EditMessageModalComponent, {
        disableClose: true,
        width: '32vw',
        data: {
          edit: false,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((value) => {
        if (value) {
          this.loadMessages();
        }
      });
  }

  buttonClick(i: number) {
    switch (i) {
      case 0:
        this.commonUtils.convertBase64toPdf(PDF, 'GSL_Guide');
        break;
      case 1:
        const nonUrgentAnchor = document.createElement('a');
        nonUrgentAnchor.href = 'mailto:UPSTundraTeam@ups.com';
        nonUrgentAnchor.click();
        nonUrgentAnchor.remove();
        break;
      case 2:
        const urgentAnchor = document.createElement('a');
        urgentAnchor.href =
          'https://upsprod.service-now.com/sp?id=kb_article&sysparm_article=kb0014954';
        urgentAnchor.target = '_blank';
        urgentAnchor.click();
        urgentAnchor.remove();
        break;
    }
  }
}
